import React from 'react';
import { LuLoader2 } from 'react-icons/lu';

const MainLoader = ({ label = 'Loading…' }) => (
  <div className="flex min-h-[50vh] w-full flex-col items-center justify-center gap-4 py-10" role="status">
    <div className="relative">
      <div className="absolute -inset-1 animate-pulse rounded-full bg-primary opacity-30 blur-md" aria-hidden="true" />
      <LuLoader2 className="relative h-8 w-8 animate-spin text-primary" aria-hidden="true" />
    </div>
    <p className="animate-pulse text-base font-medium text-foreground">{label}</p>
  </div>
);

export default MainLoader;
